import { Suspense } from 'react'

import modalService from '@/service/modal.service'
import { lazyWithRecovery } from '@/utils/lazyWithRecovery'

// PC 에서 버튼을 눌렀을 때만 쓰는 연출이라 GNB 와 같은 청크에 싣지 않는다
const QrScanMotion = lazyWithRecovery(() => import('./QrScanMotion'))

export const openQrPcNotice = () => {
  modalService.openConfirmModal({
    title: 'QR 채점은 태블릿·휴대폰에서 할 수 있습니다',
    content: (
      <>
        <Suspense fallback={null}>
          <QrScanMotion />
        </Suspense>
        태블릿·휴대폰에서 선생님앱에 로그인하고 위쪽 QR 아이콘을 눌러 학습지 QR을 찍어 주세요.
      </>
    ),
    hasCancelButton: false,
    onClick: () => modalService.closeModal(),
  })
}
